__turbopack_context__.v({
  "button": "SubmitButton-module__ioW8aG__button",
  "buttonContainer": "SubmitButton-module__ioW8aG__buttonContainer",
});
